/* MapleWeld product page (mwh-pdp.js)
   Drives sections/mwh-product, mwh-product-details and mwh-product-recs.
   No jQuery, no Molla product JS. Safe to load twice (guarded per element).

   Cart: POST /cart/add.js, update the MapleWeld header count, then hand over
   to the theme's Shopify.KT_getCart() so Molla's drawer refreshes and opens
   exactly as it always has. If that function is missing, go to /cart. */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ---------------- money ---------------- */
  function money(cents, fmt) {
    fmt = fmt || '${{amount}}';
    cents = Number(cents) || 0;
    function withDelims(n, prec, thou, dec) {
      var parts = (n / 100).toFixed(prec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts[1] ? parts[0] + dec + parts[1] : parts[0];
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return withDelims(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelims(cents, 2, "'", '.');
        default: return withDelims(cents, 2, ',', '.');
      }
    });
  }

  /* ================================================================
     GALLERY
     ================================================================ */
  function gallery(root) {
    var g = $('[data-mwg]', root);
    if (!g || g.dataset.ready) return null;
    g.dataset.ready = '1';
    var track = $('[data-mwg-track]', g);
    if (!track) return null;
    var slides = $$('[data-mwg-slide]', track);
    var thumbs = $$('[data-mwg-thumb]', g);
    var counter = $('[data-mwg-i]', g);
    var current = 0;

    function setActive(i) {
      current = i;
      thumbs.forEach(function (t, k) {
        var on = k === i;
        t.classList.toggle('is-on', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        if (on && t.parentNode.scrollWidth > t.parentNode.clientWidth) {
          var p = t.parentNode;
          var left = t.offsetLeft - (p.clientWidth - t.offsetWidth) / 2;
          p.scrollTo({ left: left, behavior: reduce ? 'auto' : 'smooth' });
        }
      });
      if (counter) counter.textContent = String(i + 1);
      /* pause any playing video that has scrolled away */
      slides.forEach(function (s, k) {
        if (k === i) return;
        var v = s.querySelector('video');
        if (v && !v.paused) v.pause();
      });
    }

    function go(i, instant) {
      if (i < 0) i = slides.length - 1;
      if (i >= slides.length) i = 0;
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: (instant || reduce) ? 'auto' : 'smooth' });
      setActive(i);
    }

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var w = track.clientWidth || 1;
        var i = Math.round(track.scrollLeft / w);
        if (i !== current && i >= 0 && i < slides.length) setActive(i);
      });
    }, { passive: true });

    var prev = $('[data-mwg-prev]', g), next = $('[data-mwg-next]', g);
    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { go(parseInt(t.getAttribute('data-mwg-thumb'), 10)); });
    });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1); }
    });

    /* external video: load the iframe only on click */
    $$('[data-mwg-embed]', g).forEach(function (b) {
      b.addEventListener('click', function () {
        var src = b.getAttribute('data-mwg-embed');
        if (!src) return;
        var f = document.createElement('iframe');
        f.src = src;
        f.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        f.setAttribute('allowfullscreen', '');
        f.title = b.getAttribute('aria-label') || 'Product video';
        f.className = 'mwg__iframe';
        b.replaceWith(f);
      });
    });

    /* start on the variant's image without animating */
    var start = g.getAttribute('data-start');
    if (start) {
      var si = slides.findIndex(function (s) { return s.getAttribute('data-media-id') === start; });
      if (si > 0) requestAnimationFrame(function () { go(si, true); });
    }

    /* ---------- full-screen viewer ---------- */
    var lb = $('[data-mwg-lb]', g);
    var lbImg = lb && $('[data-mwg-lbimg]', lb);
    var lbStage = lb && $('[data-mwg-lbstage]', lb);
    var lbCount = lb && $('[data-mwg-lbcount]', lb);
    var imgs = slides.map(function (s) { return s.querySelector('img[data-full]'); });
    var imgIdx = [];
    imgs.forEach(function (im, k) { if (im) imgIdx.push(k); });
    var lbPos = 0;

    function lbShow(pos) {
      if (!imgIdx.length) return;
      if (pos < 0) pos = imgIdx.length - 1;
      if (pos >= imgIdx.length) pos = 0;
      lbPos = pos;
      var im = imgs[imgIdx[pos]];
      lbStage.classList.remove('is-zoom');
      lbImg.style.transformOrigin = '';
      lbImg.src = im.getAttribute('data-full');
      lbImg.alt = im.alt || '';
      if (lbCount) lbCount.textContent = (pos + 1) + ' / ' + imgIdx.length;
    }
    function lbOpen(slideIndex) {
      if (!lb || !lb.showModal) return;
      var pos = imgIdx.indexOf(slideIndex);
      lbShow(pos < 0 ? 0 : pos);
      lb.showModal();
      document.documentElement.classList.add('mwg-lock');
    }
    if (lb) {
      $$('[data-mwg-open]', g).forEach(function (b) {
        b.addEventListener('click', function () { lbOpen(parseInt(b.getAttribute('data-mwg-open'), 10)); });
      });
      lb.addEventListener('close', function () {
        document.documentElement.classList.remove('mwg-lock');
        var slideIndex = imgIdx[lbPos];
        if (typeof slideIndex === 'number') go(slideIndex, true);
      });
      $('[data-mwg-lbclose]', lb).addEventListener('click', function () { lb.close(); });
      $('[data-mwg-lbprev]', lb).addEventListener('click', function () { lbShow(lbPos - 1); });
      $('[data-mwg-lbnext]', lb).addEventListener('click', function () { lbShow(lbPos + 1); });
      lb.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') lbShow(lbPos + 1);
        if (e.key === 'ArrowLeft') lbShow(lbPos - 1);
      });
      lb.addEventListener('click', function (e) { if (e.target === lb) lb.close(); });
      lbStage.addEventListener('click', function (e) {
        if (e.target !== lbImg) { lb.close(); return; }
        var r = lbImg.getBoundingClientRect();
        lbImg.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
        lbStage.classList.toggle('is-zoom');
      });
      lbStage.addEventListener('mousemove', function (e) {
        if (!lbStage.classList.contains('is-zoom')) return;
        var r = lbStage.getBoundingClientRect();
        lbImg.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
      });
      /* swipe in the viewer */
      var sx = null;
      lbStage.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      lbStage.addEventListener('touchend', function (e) {
        if (sx === null || lbStage.classList.contains('is-zoom')) return;
        var dx = e.changedTouches[0].clientX - sx; sx = null;
        if (Math.abs(dx) > 50) lbShow(lbPos + (dx < 0 ? 1 : -1));
      });
    }

    return {
      toMedia: function (mediaId) {
        if (!mediaId) return;
        var i = slides.findIndex(function (s) { return s.getAttribute('data-media-id') === String(mediaId); });
        if (i >= 0 && i !== current) go(i);
      }
    };
  }

  /* ================================================================
     BUY BOX
     ================================================================ */
  function product(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    root.classList.add('is-js');

    var variants = [];
    var cfg = {};
    try { variants = JSON.parse($('[data-mwp-variants]', root).textContent); } catch (e) { variants = []; }
    try { cfg = JSON.parse($('[data-mwp-cfg]', root).textContent); } catch (e) { cfg = {}; }
    var fmt = root.getAttribute('data-money') || '${{amount}}';
    var form = document.getElementById(root.getAttribute('data-form'));
    var select = $('[data-mwp-select]', root);
    var qty = $('[data-mwp-qty]', root);
    var atc = $('[data-mwp-atc]', root);
    var atcText = $('[data-mwp-atctext]', root);
    var msg = $('[data-mwp-msg]', root);
    var fieldsets = $$('[data-mwp-opt]', root);
    var gal = gallery(root);
    var sticky = $('[data-mwp-sticky]', root);
    var baseUrl = root.getAttribute('data-url');

    function currentVariant() {
      var id = select ? select.value : '';
      for (var i = 0; i < variants.length; i++) if (String(variants[i].id) === String(id)) return variants[i];
      return variants[0];
    }

    function chosenOptions() {
      return fieldsets.map(function (fs) {
        var r = fs.querySelector('input:checked');
        return r ? r.value : null;
      });
    }

    function findVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var k = 0; k < opts.length; k++) if (v.options[k] !== opts[k]) { ok = false; break; }
        if (ok) return v;
      }
      return null;
    }

    /* mark values that cannot be bought with the other current choices */
    function markValues(opts) {
      fieldsets.forEach(function (fs, k) {
        $$('input', fs).forEach(function (inp) {
          var test = opts.slice(); test[k] = inp.value;
          var v = findVariant(test);
          var lab = inp.closest('.mwp__val');
          lab.classList.toggle('is-na', !v);
          lab.classList.toggle('is-oos', !!v && !v.available);
        });
      });
    }

    function stockText(v) {
      var dot = $('[data-mwp-stock]', root);
      var t = $('[data-mwp-stocktext]', root);
      var state, text;
      if (!v.available) { state = 'out'; text = cfg.out || 'Out of stock'; }
      else if (v.managed && v.qty <= 0 && v.policy === 'continue') { state = 'back'; text = cfg.back || 'Available to order'; }
      else if (v.managed && v.qty > 0 && v.qty <= (cfg.low || 5)) { state = 'low'; text = (cfg.low_t || 'Only [qty] left').replace('[qty]', v.qty); }
      else { state = 'in'; text = cfg.inStock || 'In stock'; }
      if (dot && t) { dot.setAttribute('data-state', state); t.textContent = text; }

      var pk = $('[data-mwp-pickup]', root);
      var pkt = $('[data-mwp-pickuptext]', root);
      if (pk && pkt) {
        if (v.pickup && v.available) {
          var bits = v.pickup.split('|');
          pkt.textContent = (cfg.pickup || 'Pickup available at [location]').replace('[location]', bits[0]).replace('[time]', (bits[1] || '').toLowerCase()).replace(/\s[-–]\s*$/, '');
          pk.hidden = false;
        } else { pk.hidden = true; }
      }
    }

    function render(v, opts) {
      if (!v) return;
      var price = $('[data-mwp-price]', root);
      var cmp = $('[data-mwp-compare]', root);
      var save = $('[data-mwp-save]', root);
      var badge = $('[data-mwp-badge]', root);
      /* offer tier: show the price after the automatic discount, old price struck */
      var shown = v.price, strike = v.compare;
      var of = cfg.offer, op = 0;
      if (of) {
        /* per-variant % (product tier or the variant's own tier); older payloads have no map */
        if (of.v) op = +of.v[v.id] || 0;
        else if (of.price) op = +of.pct || 0;
      }
      if (op > 0 && op < 100) {
        shown = v.price - Math.floor(v.price * op / 100); /* Shopify drops the fraction of a cent */
        strike = v.price;
      }
      if (price) { price.textContent = money(shown, fmt); price.classList.toggle('is-offer', op > 0); }
      var onote = root.querySelector('[data-mw-offer-note]');
      if (onote && of) {
        onote.style.display = op > 0 ? '' : 'none';
        var ti = of.t && of.t[op];
        if (ti) {
          var nb = onote.querySelector('[data-mw-offer-nb]'), nn = onote.querySelector('[data-mw-offer-nn]');
          if (nb) { nb.textContent = ti.label; nb.style.background = ti.bg; nb.style.color = ti.fg; }
          if (nn) {
            nn.textContent = '';
            if (ti.name) { var nbold = document.createElement('b'); nbold.textContent = ti.name; nn.appendChild(nbold); nn.appendChild(document.createTextNode(' · ')); }
            nn.appendChild(document.createTextNode('discount applied automatically at checkout'));
          }
        }
      }
      var onSale = strike > shown;
      if (cmp) { cmp.hidden = !onSale; if (onSale) cmp.textContent = money(strike, fmt); }
      if (save) { save.hidden = !onSale; if (onSale) save.textContent = 'Save ' + money(strike - shown, fmt); }
      if (badge) {
        if (onSale) { badge.textContent = '-' + Math.round((v.compare - v.price) * 100 / v.compare) + '%'; badge.hidden = false; }
        else badge.hidden = true;
      }
      var sku = $('[data-mwp-sku]', root), skuw = $('[data-mwp-skuwrap]', root);
      if (sku) sku.textContent = v.sku || '';
      if (skuw) skuw.hidden = !v.sku;

      var label = v.available ? 'Add to cart' : 'Sold out';
      if (atc) atc.disabled = !v.available;
      if (atcText) atcText.textContent = label;
      var dyn = $('[data-mwp-dyn]', root);
      if (dyn) dyn.hidden = !v.available;

      fieldsets.forEach(function (fs, k) {
        var b = fs.querySelector('[data-mwp-optval]');
        if (b) b.textContent = v.options[k];
      });
      stockText(v);
      markValues(opts || v.options);

      if (sticky) {
        var sp = $('[data-mwp-stickyprice]', sticky), sv = $('[data-mwp-stickyvar]', sticky);
        var sb = $('[data-mwp-stickyatc]', sticky), st = $('[data-mwp-stickytext]', sticky);
        if (sp) sp.textContent = money(shown, fmt);
        if (sv && root.getAttribute('data-single') !== 'true') sv.textContent = v.title + ' · ';
        if (sb) sb.disabled = !v.available;
        if (st) st.textContent = label;
      }
    }

    function selectVariant(v, fromUser) {
      if (!v || !select) return;
      if (String(select.value) !== String(v.id)) {
        select.value = String(v.id);
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      fieldsets.forEach(function (fs, k) {
        $$('input', fs).forEach(function (inp) { inp.checked = inp.value === v.options[k]; });
      });
      render(v);
      if (gal && v.media) gal.toMedia(v.media);
      if (fromUser && window.history && history.replaceState) {
        history.replaceState({}, '', baseUrl + '?variant=' + v.id);
      }
      if (msg) msg.textContent = '';
    }

    fieldsets.forEach(function (fs, k) {
      fs.addEventListener('change', function () {
        var opts = chosenOptions();
        var v = findVariant(opts);
        if (!v) {
          /* combination does not exist: keep the value just picked, take the
             first variant that has it (prefer one that is in stock) */
          var picked = opts[k];
          var pool = variants.filter(function (x) { return x.options[k] === picked; });
          v = pool.filter(function (x) { return x.available; })[0] || pool[0];
        }
        selectVariant(v, true);
      });
    });

    if (select) select.addEventListener('change', function () {
      var v = currentVariant();
      render(v);
    });

    /* quantity stepper */
    $$('[data-mwp-step]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var n = (parseInt(qty.value, 10) || 1) + parseInt(b.getAttribute('data-mwp-step'), 10);
        qty.value = Math.max(1, n);
        qty.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    if (qty) qty.addEventListener('blur', function () { if (!(parseInt(qty.value, 10) >= 1)) qty.value = 1; });

    /* add to cart */
    function setBusy(on, text) {
      [atc, sticky && $('[data-mwp-stickyatc]', sticky)].forEach(function (b) {
        if (!b) return;
        b.classList.toggle('is-busy', on);
        if (on) b.setAttribute('aria-busy', 'true'); else b.removeAttribute('aria-busy');
      });
      if (text) {
        if (atcText) atcText.textContent = text;
        var st = sticky && $('[data-mwp-stickytext]', sticky);
        if (st) st.textContent = text;
      }
    }

    function updateHeaderCount() {
      return fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          $$('[data-mwh-cart-count]').forEach(function (n) { n.textContent = cart.item_count; });
          $$('.mwh-cart').forEach(function (a) { a.setAttribute('aria-label', 'Cart, ' + cart.item_count + ' item' + (cart.item_count === 1 ? '' : 's')); });
          return cart;
        }).catch(function () {});
    }

    if (form) form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      var v = currentVariant();
      if (!v || !v.available) return;
      var q = Math.max(1, parseInt(qty && qty.value, 10) || 1);
      setBusy(true, 'Adding…');
      if (msg) { msg.textContent = ''; msg.classList.remove('is-err'); }
      fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: v.id, quantity: q }] })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.j && (res.j.description || res.j.message) || 'Could not add to cart');
          setBusy(false, 'Added ✓');
          if (msg) msg.textContent = q + ' × ' + (v.title === 'Default Title' ? 'item' : v.title) + ' added to your cart.';
          updateHeaderCount();
          if (window.Shopify && typeof Shopify.KT_getCart === 'function') {
            try { Shopify.KT_getCart(); } catch (err) {}
          } else {
            window.location.href = root.getAttribute('data-cart') || '/cart';
          }
          document.dispatchEvent(new CustomEvent('mwp:added', { detail: { variant: v, quantity: q } }));
          setTimeout(function () { render(currentVariant()); }, 2200);
        })
        .catch(function (err) {
          setBusy(false);
          render(currentVariant());
          if (msg) { msg.textContent = err.message; msg.classList.add('is-err'); }
        });
    });

    /* sticky bar */
    if (sticky && atc && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var e = entries[0];
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-on', show);
        document.documentElement.classList.toggle('mwp-sticky-up', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        var b = $('[data-mwp-stickyatc]', sticky);
        if (b) b.tabIndex = show ? 0 : -1;
      }, { threshold: 0 });
      io.observe(atc);
    }

    /* copy link */
    $$('[data-mwp-copy]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var url = window.location.href;
        var done = function () {
          var s = b.querySelector('span'); var old = s.textContent;
          s.textContent = b.getAttribute('data-done') || 'Copied';
          setTimeout(function () { s.textContent = old; }, 1800);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(done, done);
        else { var t = document.createElement('textarea'); t.value = url; document.body.appendChild(t); t.select(); try { document.execCommand('copy'); } catch (e) {} t.remove(); done(); }
      });
    });

    /* "Select" buttons in the sizes & pricing table */
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-mwd-pick]');
      if (!b) return;
      var id = b.getAttribute('data-mwd-pick');
      var v = variants.filter(function (x) { return String(x.id) === id; })[0];
      if (!v) return;
      selectVariant(v, true);
      var target = $('.mwp__info', root) || root;
      var y = target.getBoundingClientRect().top + window.pageYOffset - 16;
      window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
      setTimeout(function () { if (atc) atc.focus({ preventScroll: true }); }, reduce ? 0 : 500);
    });

    render(currentVariant());
  }

  /* ================================================================
     DETAILS: sticky menu, scroll-spy, description clamp
     ================================================================ */
  function details(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var links = $$('[data-mwd-link]', root);
    var nav = $('[data-mwd-nav]', root);
    if (links.length < 2 && nav) nav.hidden = true;

    if ('IntersectionObserver' in window && links.length) {
      var map = {};
      links.forEach(function (a) { map[a.getAttribute('href').slice(1)] = a; });
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          links.forEach(function (a) { a.classList.remove('is-on'); a.removeAttribute('aria-current'); });
          var a = map[en.target.id];
          if (a) {
            a.classList.add('is-on'); a.setAttribute('aria-current', 'true');
            var p = a.parentNode;
            if (p.scrollWidth > p.clientWidth) p.scrollTo({ left: a.offsetLeft - 16, behavior: reduce ? 'auto' : 'smooth' });
          }
        });
      }, { rootMargin: '-35% 0px -55% 0px' });
      Object.keys(map).forEach(function (id) { var el = document.getElementById(id); if (el) io.observe(el); });
    }

    links.forEach(function (a) {
      a.addEventListener('click', function (e) {
        var el = document.getElementById(a.getAttribute('href').slice(1));
        if (!el) return;
        e.preventDefault();
        var off = (nav && !nav.hidden ? nav.offsetHeight : 0) + 12;
        window.scrollTo({ top: el.getBoundingClientRect().top + window.pageYOffset - off, behavior: reduce ? 'auto' : 'smooth' });
        if (history.replaceState) history.replaceState({}, '', '#' + el.id);
      });
    });

    var clamp = $('[data-mwd-clamp]', root);
    var more = $('[data-mwd-more]', root);
    if (clamp && more) {
      var check = function () {
        var tall = clamp.scrollHeight > 960;
        more.hidden = !tall;
        clamp.classList.toggle('is-clamped', tall && more.getAttribute('aria-expanded') !== 'true');
      };
      more.addEventListener('click', function () {
        var open = more.getAttribute('aria-expanded') === 'true';
        more.setAttribute('aria-expanded', open ? 'false' : 'true');
        more.querySelector('span').textContent = open ? 'Read the full description' : 'Show less';
        clamp.classList.toggle('is-clamped', open);
        if (open) clamp.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      });
      check();
      window.addEventListener('load', check);
    }

    /* wide tables and iframes inside descriptions scroll instead of overflowing */
    $$('.mwd__rte table', root).forEach(function (t) {
      if (t.parentNode.classList.contains('mwd__tscroll')) return;
      var w = document.createElement('div'); w.className = 'mwd__tscroll';
      t.parentNode.insertBefore(w, t); w.appendChild(t);
    });
  }

  /* ================================================================
     RELATED PRODUCTS
     ================================================================ */
  function recs(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    function wire() {
      var row = $('[data-mwr-row]', root);
      var prev = $('[data-mwr-prev]', root), next = $('[data-mwr-next]', root);
      if (!row) return;
      var step = function (d) { row.scrollBy({ left: d * row.clientWidth * 0.85, behavior: reduce ? 'auto' : 'smooth' }); };
      if (prev) prev.onclick = function () { step(-1); };
      if (next) next.onclick = function () { step(1); };
      var arrows = $('.mwr__arrows', root);
      if (arrows) arrows.hidden = row.scrollWidth <= row.clientWidth + 4;
      root.hidden = !row.children.length;
    }
    wire();
    var row = $('[data-mwr-row]', root);
    if (row && row.hasAttribute('data-mwr-final')) return;
    var url = root.getAttribute('data-url');
    if (!url || !window.fetch) return;
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-mwr-row]');
        if (fresh && fresh.children.length) {
          $('[data-mwr-row]', root).replaceWith(document.importNode(fresh, true));
          wire();
        }
      })
      .catch(function () {});
  }

  function init() {
    $$('[data-mwp]').forEach(product);
    $$('[data-mwd]').forEach(details);
    $$('[data-mwr]').forEach(recs);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();